import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  environment: '',
};

export const environmentSlice = createSlice({
  name: 'environment',
  initialState,
  reducers: {
    setEnvironment: (state, action) => {
      state.environment = action.payload;
    },
  },
});

export const { setEnvironment } = environmentSlice.actions;

// Selector with safety check
export const selectEnvironment = (state) => state.environment?.environment || 'Production';

// Helper function to check if environment is Development or UAT
export const isDevelopmentOrUAT = (state) => {
  const env = state.environment?.environment || 'Production';
  return env === 'Development' || env === 'UAT';
};

export default environmentSlice.reducer;